/**
 * ENTRY POINT
 *
 * In HTML, load only this file:
 *   <script type="module" src="js/app.js"></script>
 *
 * Add to HTML <head> for map (choose one):
 *   Neshan:  <script src="https://static.neshan.org/sdk/mapboxgl/v1.3.2/neshan-mapboxgl.js"></script>
 *   Balad:   <script src="https://balad.ir/api/mapkit/v4/mapkit.js" data-balad-token="YOUR_KEY"></script>
 */

import { AppModel }     from './model.js';
import { AppPresenter } from './presenter.js';

window.addEventListener('DOMContentLoaded', async () => {
  const model     = new AppModel();
  const presenter = new AppPresenter(model);
  await presenter.init();
});
